import React from 'react';
import { CssBaseline } from '@material-ui/core';
import MenuPainel from '../components/MenuPainel';
import AdmAcionamento from '../components/Acionamento';
import { ChangePassword } from '../components/ChangePassword';
import PaperForm from '../components/PaperForm';
import GlobalStyle from '../styles/globalStyle';

class Acionamento extends React.Component {
  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <GlobalStyle />
        <ChangePassword />
        <MenuPainel stepper='Acionamento Manual'>
          <PaperForm
            title={''}
            margin={'15px 0'}
            elevation={24}
            componente={<AdmAcionamento />}
          ></PaperForm>
        </MenuPainel>
      </React.Fragment>
    );
  }
}

const connectedAssinar = Acionamento;
export { connectedAssinar as Acionamento };
